import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FILE_UPLOADER} from "../../../../../componentes/file-uploader/file-uploader.component";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-conta-bancaria',
  templateUrl: './conta-bancaria.component.html',
  styleUrls: ['./conta-bancaria.component.css']
})
export class ContaBancariaComponent implements OnInit {

  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader: any;
  @Input() formGroup!: FormGroup;
  @Input() formSubmitted = false;
  @Input() readonly!: boolean;
  @Input() arquivosSalvos!: any[];

  banco = [
    { value: '341', nome: 'Itaú Unibanco S.A.'}];

  opcoesTipoConta = [
    {val: 'CC', label: 'Conta Corrente (Única opção disponível)'},
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit() {}

  get arquivoControl(): FormArray {
    return this.formGroup.get('arquivo') as FormArray;
  }

  onArquivosChange(arquivos: any[]) {
    this.arquivoControl.clear();

    arquivos.forEach(arq => {
      this.arquivoControl.push(this.fb.group({
        nomeArquivo: arq.nomeArquivo,
        conteudo: arq.conteudo
      }));
    });

    this.arquivoControl.markAsTouched();
    this.arquivoControl.updateValueAndValidity();
  }
}
